import { useState } from "react";
import Sidebar from "../components/layout/Sidebar";
import swal from "sweetalert";
import { sendRequest, refreshToken, validateEmail, vIndiaphone, onlyLetters } from "../utils/helpers";
const CoPassengerProfilePage = () => {
  const [passengers, setPassengers] = useState([
    { first_name: "", last_name: "", email: "", mobile: "" },
  ]);
  const [errors, setErrors] = useState([
    { first_name: "", last_name: "", email: "", mobile: "" },
  ]);
  const [loading, setLoading] = useState(false);

  

  const addPassenger = () => {
    setPassengers([
      ...passengers,
      {  first_name: "", last_name: "", email: "", mobile: "" },
    ]);
    setErrors([
      ...errors,
      { first_name: "", last_name: "", email: "", mobile: "" },
    ]);
  };

  const removePassenger = (index) => {
    if (passengers.length === 1) return;
    const updated = passengers.filter((_, i) => i !== index);
    setPassengers(updated);

    const updatedErrors = errors.filter((_, i) => i !== index);
    setErrors(updatedErrors);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...passengers];
    updated[index][name] = value;
    setPassengers(updated);
    const updatedErrors = [...errors];
    if (updatedErrors[index]) {
      updatedErrors[index][name] = "";
      setErrors(updatedErrors);
    }
  };
  const validatePassengers = () => {
    let isValid = true;

    const newErrors = passengers.map((pax) => ({
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
    }));

    passengers.forEach((pax, index) => {
      // First name
      if (!pax.first_name.trim()) {
        newErrors[index].first_name = "First name is required.";
        isValid = false;
      } else if (!onlyLetters(pax.first_name.trim())) {
        newErrors[index].first_name = "First name should contain only letters.";
        isValid = false;
      }

      // Last name
      if (!pax.last_name.trim()) {
        newErrors[index].last_name = "Last name is required.";
        isValid = false;
      } else if (!onlyLetters(pax.last_name.trim())) {
        newErrors[index].last_name = "Last name should contain only letters.";
        isValid = false;
      }

      // Email (optional, but if filled then format check)
      if (pax.email && pax.email.trim()) {
        if (!validateEmail(pax.email.trim())) {
          newErrors[index].email = "Please enter a valid email address.";
          isValid = false;
        }
      }

      // Mobile (required + India phone format)
      if (!pax.mobile.trim()) {
        newErrors[index].mobile = "Mobile number is required.";
        isValid = false;
      } else if (!vIndiaphone(pax.mobile.trim())) {
        newErrors[index].mobile = "Please enter a valid Indian mobile number.";
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const ok = validatePassengers();
      if (!ok) {
        setLoading(false);
        return; // stop submit if validation fails
      }
      // console.log("passengers => ",passengers);
      const payload = {
        first_name: passengers.map((pax) => pax.first_name || ""),
        last_name: passengers.map((pax) => pax.last_name || ""),
        email: passengers.map((pax) => pax.email || ""),
        mobile: passengers.map((pax) => pax.mobile || ""),
      };

      const res = await sendRequest(payload, "me/travelers");

      // const res = await sendRequest(passengers, "me/travelers");
  
      if (!res || ![200, 201].includes(res.status)) {
        console.error("bulk save error:", res);
        swal(res?.message || "Something went wrong while saving passengers!");
        return;
      }
  
      if (res && [200, 201].includes(res.status)) {
        const token = res.token;
        if (token) {
          await refreshToken(token);
        }
        
      }
      swal(res?.message || "Co-Passenger details saved successfully!");
      // swal("Passengers saved successfully.");

      
    } catch (error) {
      console.error("Error saving passengers", error);
      alert("Network error while saving passengers!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="bgdashboard"></div>
      <Sidebar />
      <div className="dashboardMain sidebarPadding mainPanel">
        <div className="mainPanelIN">
          <div className="relative">
          <section className="documentsBanner">

  <div className="documentsBannerIcon">
    <div className="documentIcon">
      <i className="fa-solid fa-user-group"></i>
    </div>
  </div>

  <div className="documentsBannerContent">
    <h3>Co-Passenger Profile</h3>

    <p>
      Manage your co-passenger details and information for a smooth travel experience.
    </p>
  </div>

  {/* Decorative Travel Skyline */}
  <div className="documentsSkyline">
    <span className="skylineBuilding building1"></span>
    <span className="skylineBuilding building2"></span>
    <span className="skylineBuilding building3"></span>
    <span className="skylineBuilding building4"></span>

    <span className="skylineTower tower1"></span>
    <span className="skylineTower tower2"></span>
    <span className="skylineTower tower3"></span>

    <div className="travelBridge"></div>

    <i className="fa-solid fa-plane skylinePlane"></i>
  </div>

</section>
            <div className="founderCard p-3 mb-3 rounded-3 text-center">
              

              <form onSubmit={handleSubmit} className="row justify-content-center">
                <div className="col-md-12">
                  {passengers.map((pax, index) => (
                    <div
                      key={index}
                      className="founderCard p-3 mb-3 rounded-3"
                    >
                      <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                        <h6 className="m-0">Passenger #{index + 1}</h6>
                        {passengers.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removePassenger(index)}
                          >
                            <i className="fa fa-trash me-1"></i> Remove
                          </button>
                        )}
                      </div>

                      <div className="row text-start">
                        <div className="form-group mb-2 col-sm-6">
                          <label>First Name</label>
                          <input
                            type="text"
                            name="first_name"
                            className="inputBoxIn form-control forminput w-100"
                            placeholder="Enter first name"
                            value={pax.first_name}
                            onChange={(e) => handleChange(index, e)}
                            required
                          />
                           {errors[index]?.first_name && (
                            <small className="text-danger">
                              {errors[index].first_name}
                            </small>
                          )}
                        </div>
                        <div className="form-group mb-2 col-sm-6">
                          <label>Last Name</label>
                          <input
                            type="text"
                            name="last_name"
                            className="inputBoxIn form-control forminput w-100"
                            placeholder="Enter first name"
                            value={pax.last_name}
                            onChange={(e) => handleChange(index, e)}
                            required
                          />
                           {errors[index]?.last_name && (
                            <small className="text-danger">
                              {errors[index].last_name}
                            </small>
                          )}
                        </div>

                        <div className="form-group mb-2 col-sm-6">
                          <label>Email Address</label>
                          <input
                            type="email"
                            name="email"
                            className="inputBoxIn form-control forminput w-100"
                            placeholder="Enter email"
                            value={pax.email}
                            onChange={(e) => handleChange(index, e)}
                          />
                           {errors[index]?.email && (
                            <small className="text-danger">
                              {errors[index].email}
                            </small>
                          )}
                        </div>

                        <div className="form-group mb-2 col-sm-6">
                          <label>Mobile Number</label>
                          <input
                            type="text"
                            name="mobile"
                            className="inputBoxIn form-control forminput w-100"
                            placeholder="+91 XXXXX XXXXX"
                            value={pax.mobile}
                            onChange={(e) => handleChange(index, e)}
                            required
                          />
                           {errors[index]?.mobile && (
                            <small className="text-danger">
                              {errors[index].mobile}
                            </small>
                          )}
                        </div>

                        {/* <div className="form-group mb-2 col-sm-6">
                          <label>Role / Designation</label>
                          <input
                            type="text"
                            name="role"
                            className="inputBoxIn form-control forminput w-100"
                            placeholder="e.g. Co-Passenger, Friend, Relative"
                            value={pax.role}
                            onChange={(e) => handleChange(index, e)}
                          />
                        </div> */}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="d-flex justify-content-between flex-wrap">
                  <div className="formHere mb-2 order-2 order-md-1">
                    <button
                      type="submit"
                      disabled={loading}
                      className="text-center mt-2 mybtn d-flex gap-2 align-items-center w-100 m-auto"
                    >
                      <span className="bgIN">
                        {loading ? "Saving..." : "Save Co-Passenger Profile"}
                      </span>
                    </button>
                  </div>

                  <div className="text-center mb-2 order-1 order-md-2">
                    <button
                      type="button"
                      className="secondaryBtn text-center mt-2 mybtn d-flex gap-2 align-items-center w-100 m-auto btn-primary"
                      onClick={addPassenger}
                    >
                      <span className="bgIN">+ Add Another Co-Passenger</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoPassengerProfilePage;
